import type { IPContext } from "@outschool/iplookup-client";

import { injectScript } from "../lib/util";
import {
  Integration,
  IntegrationCategory,
} from "../providers/AnalyticsContext";
import { AnalyticsPlugin, AnalyticsPluginType } from ".";

import type { Context } from "../types";

declare global {
  interface Window {
    wcs?: any;
    wcs_do?: any;
    _nasa?: any;
    wcs_add?: {
      [key: string]: unknown;
    };
  }
}

interface NaverPluginParams {
  locationInfo: IPContext;
}

export default class NaverPlugin implements AnalyticsPlugin {
  name = Integration.Naver;
  category = IntegrationCategory.Advertising;
  type = AnalyticsPluginType.destination;
  version = "0.1.0";

  scriptId = "os-naver";
  scriptSrc = "https://wcs.naver.net/wcslog.js";
  key = "s_5118681a88f7";

  locationInfo: IPContext;

  constructor({ locationInfo }: NaverPluginParams) {
    this.locationInfo = locationInfo;
  }

  isLoadable() {
    return this.locationInfo?.ipInfo?.country?.isoCode === "KR";
  }

  async load(): Promise<void> {
    await injectScript(this.scriptId, this.scriptSrc);

    if (!window?.wcs_add) {
      window.wcs_add = {};
    }

    window.wcs_add["wa"] = this.key;

    if (!window?._nasa) {
      window._nasa = {};
    }

    window?.wcs.inflow();
    window?.wcs_do(window?._nasa);
  }

  async unload(): Promise<void> {
    const script = document.getElementById(this.scriptId);
    script?.remove();
    window.wcs_add = undefined;
    window.wcs_do = undefined;
    window.wcs = undefined;
  }

  isLoaded() {
    if (typeof window === "undefined") {
      return false;
    }

    return !!window?.wcs;
  }

  async track(context: Context) {
    if (context.event.event !== "Order Completed") {
      return context;
    }

    const wcs = window?.wcs;

    if (!wcs) {
      return context;
    }

    const total = context.event?.properties?.total;

    window._nasa = wcs.cnv(1, total);
    window.wcs_do(window._nasa);

    return context;
  }
}
